import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

export const loadInstagramPosts =
  (): CustomerThunkAction<
    "LOADING_INSTAGRAM_USER_POSTS" | "ERROR_LOADING_INSTAGRAM_USER_POSTS" | "INSTAGRAM_USER_POSTS_SUCCESS"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/integration/social/instagram/posts"),
      () =>
        dispatch({
          type: "LOADING_INSTAGRAM_USER_POSTS",
          payload: undefined,
        }),
      error =>
        dispatch({
          type: "ERROR_LOADING_INSTAGRAM_USER_POSTS",
          payload: {
            errorMessage: error.message,
          },
        }),
      data =>
        dispatch({
          type: "INSTAGRAM_USER_POSTS_SUCCESS",
          payload: { data },
        })
    );
